import React, { useState, useRef, useEffect } from "react";

const CustomSelectFloat = ({
  label,
  value,
  options = [],
  onChange,
  error,
  touched,
  required,
  renderOption,
  renderSelected,
  className = "",
  maxHeight = "200px",
  dropdownClassName = "timezone-dropdown",
  scrollHide = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [visibleOptionsCount, setVisibleOptionsCount] = useState(20);
  const containerRef = useRef(null);

  const visibleOptions = options.slice(0, visibleOptionsCount);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleScroll = (e) => {
    const bottom = e.currentTarget.scrollHeight <= e.currentTarget.scrollTop + e.currentTarget.clientHeight + 1;
    if (bottom && visibleOptionsCount < options.length) {
      setVisibleOptionsCount(prev => prev + 20);
    }
  };

  const selectedOption = options.find(opt => opt.value === value);

  return (
    <div className={`field-block input-text ${className}`} ref={containerRef}>
      <div className={`dropdown navbar-dropdown ${dropdownClassName} ${isOpen ? "show" : ""}`}>
        <button
          className="btn border-0 navbar-dropdown__toggle px-0 w-100 text-start d-block position-relative"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
        >
          <label className="did-floating-label">
            {label}{required && <span className="asterisk"> *</span>}
          </label>
          <span className="selected-value">
            {selectedOption ? (
              renderSelected ? renderSelected(selectedOption) : selectedOption.label
            ) : ''}
          </span>
          <svg width="10" height="10" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 2L9 9 2 2" stroke="#B0B0BA" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
        </button>
        {isOpen && (
          <ul className={`dropdown-menu min-w-unset show w-100 overflow-auto ${scrollHide ? "scroll-hide" : ""}`} onScroll={handleScroll} style={{ maxHeight: maxHeight }}>
            {visibleOptions.map((opt, index) => (
              <li 
                key={`${opt.value}-${index}`} 
                className="setting-menu__item d-flex align-items-center gap-2"
                onClick={() => {
                  onChange(opt.value);
                  setIsOpen(false);
                }}
              >
                {renderOption ? renderOption(opt) : opt.label}
              </li>
            ))}
          </ul>
        )}
      </div>
      {error && touched ? <div className="input-error">{error}</div> : null}
    </div>
  );
};

export default CustomSelectFloat;
